import { TExperimentsState } from '../../types/redux/experiments';

export const defaultState = [];

export function experimentReducer(state = defaultState): TExperimentsState {
  return state;
}
